import React from "react";

import KPIComparison from "components/visuals/KPIComparison";
import useColourPalette from "components/visuals/useColourPalette";
import { Box, Typography } from "@material-ui/core";
import { useAppSelector } from "store";
import { selectIsLoading, selectHasErrors, selectLastTwelveMonthsTotalVisits, selectStoreFootfallCentiles } from "modules/customer/insights/portfolioNew/footfallNew/footfallNewSlice";
import numberFormatter from "utils/numberFormatter";
import { selectComparator, selectStore } from "modules/customer/insights/portfolioNew/portfolioSlice";

const LastTwelveMonthsTotalVisits: React.FC = () => {
    const colourPalette = useColourPalette();
    const selectedStore = useAppSelector(selectStore);
    const comparator = useAppSelector(selectComparator);
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const lastTwelveMonthsTotalVisits = useAppSelector(selectLastTwelveMonthsTotalVisits);
    const centiles = useAppSelector(selectStoreFootfallCentiles);

    const selectedStoreValueString = `${numberFormatter.toDecimalPlaces(lastTwelveMonthsTotalVisits.selectedStore, 1)}`;
    const selectedStoreCenitleString = `${numberFormatter.toOrdinalNumber(centiles.selectedStore)}`;
    const comparatorValueString = `${numberFormatter.toDecimalPlaces(lastTwelveMonthsTotalVisits.comparator, 1)}`;
    const comparatorCenitleString = `${numberFormatter.toOrdinalNumber(centiles.comparator)}`;
    const differencePositiveSign = lastTwelveMonthsTotalVisits.percentageDifference > 0 ? "+" : "";

    const label = `Average annual visits per cell within ${selectedStore?.name}'s retail centre`;
    return (
        <Box width="100%" height="100%" data-cy="average-annual-visits-per-cell">
            <KPIComparison
                isLoading={isLoading}
                hasErrors={hasErrors}
                targetValue={
                    <Typography variant="h3" component="div" style={{ color: colourPalette.comparators[0] }}>
                        {`${selectedStoreValueString} (${selectedStoreCenitleString})`}
                    </Typography>
                }
                targetLabel={label}
                comparisonValue={
                    <Typography variant="h6" component="div" style={{ color: colourPalette.comparators[1] }}>
                        {`${comparatorValueString} (${comparatorCenitleString})`}
                    </Typography>
                }
                comparisonLabel={`Comparator: ${comparator?.name}`}
                differenceValue={
                    <Typography variant="h6" component="div" style={{ color: "#FFFFFF" }}>
                        {differencePositiveSign}{numberFormatter.toPercentage(lastTwelveMonthsTotalVisits.percentageDifference)}
                    </Typography>}
                differenceLabel="Difference"
            />
        </Box>
    );
};

export default LastTwelveMonthsTotalVisits;
